import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import { Controller } from '../Controller';
import { ApiHelper } from '../helpers/ApiHelper';
import { Helper } from '../helpers/Helper';
import { UiHelper } from '../helpers/UiHelper';
import { DynamicFormDialog } from './DynamicFormDialog';

import async from 'async';
import { AppTheme } from '../../styles/AppTheme';
import { Headerbar } from './Headerbar';
import { TableComponent } from './TableComponent';
import { SubEntityComponent } from './SubEntityComponent';

export class BaseEntityPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      items: [],
      fetchState: ApiHelper.State.LOADING,
      nextPageState: ApiHelper.State.READY,
      modalOpen: false,
    };
    this.breadCrumbs = []
  }

  componentDidMount() {
    this.fetchItems();
  }

  fetchItems() {
    this.setState({
      fetchState: ApiHelper.State.LOADING
    })
    const fcns = [];
    for (const f of this.toFetch) {
      fcns.push(function (callback) {
        ApiHelper.call(f, callback);
      })
    }
    async.parallel(fcns, function (err, results) {
      if (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err)
        })
        return
      }
      //console.log('path:', this.props.match.path);
      //console.log('user:', Controller.get().userMgr().getAppUser());
      if (this.props.match.path.startsWith('/admin') &&
        !Controller.get().userMgr().isProductSU()) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: 'Your permissions does not allow accessing this page. Contact customer care team if you did not expect this.'
        })
        return
      }
      if (this.onFetchSuccess) {
        this.onFetchSuccess(results);
        this.sortResult(this.sortFields);
      }
      this.setState({
        fetchState: ApiHelper.State.READY
      })
    }.bind(this))
  }

  onFetchSuccess(results) {
    const result = results[0]
    if (!result) {
      return
    }
    if (result.fieldDef) {
      if (!this.formDefinition) {
        this.formDefinition = result.fieldDef;
      }
      this.fieldDef = result.fieldDef
    }
    this.handleNextpage(result)
    this.setState({
      items: this.state.items.concat(result.items),
    })
  }

  handleNextpage(result) {
    this.toFetchNext = Object.assign({}, this.toFetch[0])
    if (this.toFetch && this.toFetch[0] && this.toFetch[0].queryParams) {
      this.toFetchNext.queryParams = Object.assign({}, this.toFetch[0].queryParams)
    }
    if (!this.toFetchNext.queryParams) {
      this.toFetchNext.queryParams = {}
    }
    if (result.nextPage) {
      this.toFetchNext.queryParams.nextPage = result.nextPage
    }
    this.setState({
      nextPage: result.nextPage,
      nextPageState: ApiHelper.State.READY
    })
  }

  sortResult(sortFields) {
    const currentResult = this.state.items;
    if (sortFields) {
      currentResult.sort(function (a, b) {
        for (let i = 0; i < sortFields.length; i++) {
          if (a[sortFields[i]] > b[sortFields[i]]) { return 1 }
          if (a[sortFields[i]] < b[sortFields[i]]) { return -1 }
        }
        return 0
      });
      this.setState({
        items: currentResult
      })
    }
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  closeSubEntityComponent = () => {
    this.setState({
      entityProps: null
    })
  }

  getEntityProps(current, entityAttrName) {
    const entityParams = this.subEntities[entityAttrName]
    return {
      entityAttrName,
      entityItem: current,
      ...entityParams
    }
  }

  switchSubView = (current, entityAttrName) => {
    this.setState({
      entityProps: this.getEntityProps(current, entityAttrName)
    })
  }

  readyView() {
    if (this.state.entityProps) {
      const { entityProps } = this.state
      const SubEntComp = this.SubEntityComponent || SubEntityComponent
      //this.SubEntityComponent is derived SubEntityComponent
      return (
        <SubEntComp
          onCloseSubEntityComponent={this.closeSubEntityComponent}
          {...entityProps}
        >
        </SubEntComp>
      )
    }
    if (this.renderCustomReady) {
      return this.renderCustomReady()
    }

    return (
      <div className={css(Styles.entityContainer)}>
        <div className={css(Styles.row)}>
          {this.renderHeaderbar()}
        </div>
        <div className={css(Styles.row)}>
          {this.renderAboveTable()}
        </div>
        <div className={css(Styles.row)}>
          {this.renderTable()}
        </div>
        <div className={css(Styles.row)}>
          {this.renderBelowTable()}
        </div>
        {this.state.modalOpen ? this.renderModal() : ''}
        {this.state.messageToShow ? this.renderMessageModal() : ''}
      </div>
    );
  }

  renderHeaderbar() {
    const title = this.pageTitle ? this.pageTitle.toUpperCase() : null
    let actions = []
    if(this.headerActions) {
      actions = this.headerActions
    } else if(!this.noAdd) {
      actions = [{
        label: 'Add new',
        onClick: () => this.openModalForAdd()
      }]
    }
    if(this.export) {
      actions.push({
        label: 'Export',
        icon: 'file_download',
        onClick: () => this.onExport()
      })
    }
    return (
      <Headerbar
        title={title}
        actions={actions}
        actionComponents={this.state.headerActionComponents}
        breadCrumbs={this.breadCrumbs}/>
    )
  }

  onExport() {
    if(this.export && this.export.format === 'xlsx') {
      const DwnldUtil = require('../helpers/FileDownloader');

      const fileName = this.makeFileName();
      const rows = this.prepExcelDownload()
      DwnldUtil.FileDownloader.exportAsExcelFile(rows, fileName)
    }
  }

  makeFileName = () => {
    return 'doc-excel';
  }

  prepExcelDownload() {
    const rows = [];

    for (const item of this.state.items) {
      const e = {};
      for (const hKey in this.export.headers) {
        e[this.export.headers[hKey]] = this.exportRowItemValue(hKey, item)
      }
      rows.push(e);
    }

    return rows
  }

  openModalForAdd() {
    this.formDefinition.formType = 'add'
    Helper.deleteFormDefinitionValues(this.formDefinition)
    this.onAdd();
    this.setState({
      modalOpen: true
    });
  }

  openModalForEdit(current) {
    //console.log('edit:', current);
    this.formDefinition.formType = 'edit'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.onEdit(current);
    this.setState({
      modalOpen: true
    });
  }

  openModalForApproval(current) {
    //console.log('approve:', current);
    this.formDefinition.formType = 'approve'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.onApprove(current);
    this.setState({
      modalOpen: true
    });
  }

  openModalForDelete(current) {
    this.formDefinition.formType = 'delete'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.onDelete(current);
    this.setState({
      modalOpen: true
    });
  }

  renderModal() {
    return (
      <DynamicFormDialog
        apiMethod={this.state.apiMethod}
        apiEndPoint={this.state.apiEndPoint}
        apiData={this.state.apiData || this.apiData}
        formDefinition={this.formDefinition}
        isOpen={this.state.modalOpen}
        onClosed={() => this.setState({ modalOpen: false })}
        customSubmit={this.customSubmit && this.customSubmit.bind(this)}
        onCompleteAction={() => {
          this.setState({ modalOpen: false, items: [] })
          this.fetchItems()
        }
        }
      >
      </DynamicFormDialog>
    );

  }

  renderAboveTable() {
    return ('')
  }

  renderTable() {
    return (
      < TableComponent
        tableHeaders={this.tableHeaders}
        onTableValue={this.onTableValue ? this.onTableValue.bind(this) : this.onTableValue}
        tableHeadersMap={this.tableHeadersMap}
        items={this.state.items}
        setItems={this.setItems}
        headerActions={this.headerActions} //Multi checkbox
        onActions={this.onActions.bind(this)}
        nextPage={this.state.nextPage}
        nextPageState={this.state.nextPageState}
        onNext={this.onNext.bind(this)}
        emptyText={this.emptyText}
        cellWidths={this.cellWidths}
      />
    )
  }

  renderBelowTable() {
    return ('')
  }

  fetchNext() {
    const fcns = [];
    const tofetch = []
    tofetch.push(this.toFetchNext)
    for (const f of tofetch) {
      fcns.push(function (callback) {
        ApiHelper.call(f, callback);
      })
    }
    async.parallel(fcns, function (err, results) {
      if (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err)
        })
        return
      }
      this.onFetchNextSuccess(results)
    }.bind(this))
  }

  onNext = () => {
    this.setState({ nextPageState: ApiHelper.State.LOADING })
    this.fetchNext()
  }

  setItems = (itemsList) => {
    this.setState({ items: itemsList })
  }
}
const Styles = StyleSheet.create({
  entityContainer: {
    marginTop: AppTheme.toolbarHeight + AppTheme.toolbarHeight,
    paddingTop: 20,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    backgroundColor: AppTheme.primaryBg
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
})



// WEBPACK FOOTER //
// ./src/common/components/BaseEntityPage.js